import 'core-js/modules/es.array.find'
import 'core-js/modules/es.string.starts-with'
import '@/assets/css/base.less'
import '@lib/gjsapi' // -> now, u can use window.ggj
import GGJSkuSelector from '@lib/ggj-sku-selector'
import '@lib/ggj-sku-selector/dist/style.css'
import analytics from '@lib/vue-analytics'
import VueLazyload from '@lib/ggj-vue-lazyload'
import VueHybrid from './HybridUtils'
import Ganaly from '@/utils/ganaly'
import { Toast } from '@lib/gant'
import { Stepper } from 'vant'
import '@/assets/css/my-vant.less'

// 暂时注释
import { Tools } from '@lib/ggj-utils'
import qs from "./qs.js"
if (Tools.isWxMini) {
  let query = qs.parse(window.location.search.slice(1));
  Tools.setYxInfo(query)
}


// document.cookie = "gjsessionc=eyJ1aWQiOjEzMTE2NzMzNjEsImNyZWF0ZVRpbWUiOjE1OTQzNTA3OTIsImV4cGlyZVRpbWUiOjE1OTU3MDgyMzIsImF0dHJNYXAiOnsiJHNyYyI6IjQjMSIsImxvZ2luU3RhdHVzIjoiMSJ9fQ==.a08a3fdb98840b673538bda607080cf5361; path=/";
// document.cookie = "_ggj_aid_=1311673361; path=/";

const Vue = window.Vue

// Vue.use(VueLazyload)
Vue.prototype.Ganaly = new Ganaly()
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'https://cdn.gegejia.com/fe-ui/ssyh/lazyerror.png',
  loading: 'https://cdn.gegejia.com/fe-ui/ssyh/lazyloading.png',
})
Vue.use(GGJSkuSelector)
Vue.use(VueHybrid)
Vue.use(Toast)
Vue.use(Stepper)
Vue.use(analytics, {
  'gj-ua': 4,
})


export function render(rootComponent) {
  new Vue({
    el: '#app',
    render(h) {
      return h(rootComponent)
    },
  })
}
